import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";
import { Paragraph } from "@datagame/ui";

import styles from "./Step.module.scss";

const cx = classNames.bind(styles);

interface StepProps {
  title: string;
  icon: ReactElement;
  isActive: boolean;
  step: number;
  onClick: () => void;
}

export const Step = (props: StepProps) => {
  const { title, icon, isActive, step, onClick } = props;
  const { t } = useTranslation("project");

  return (
    <button type="button" className={cx("step", { active: isActive })} onClick={onClick}>
      <div className={styles.icon}>{icon}</div>
      <div>
        <span className={styles.header}>{t("navigation.step", { number: step + 1 })}</span>
        <Paragraph weight="font-bold" className={styles.title}>
          {title}
        </Paragraph>
      </div>
    </button>
  );
};
